module.exports = __webpack_public_path__ + "img/plusfl_5x.8b7582ef.png";